var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "container is-hidden-mobile" }, [
    _c(
      "div",
      { staticClass: "flex justify-around items-center flex-wrap mx-4 my-4" },
      _vm._l(_vm.partners, function(partner) {
        return _c("div", { staticClass: "w-1/8 text-center" }, [
          _c("a", { attrs: { href: partner.url[_vm.currentLanguage] } }, [
            _c("img", {
              attrs: {
                src: "/static/partners/" + partner.id + "-square.png",
                alt: ""
              }
            })
          ])
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b5c6770e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5c6770e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Doctor/PartnersList.vue
// module id = 805
// module chunks = 1